"use strict";

(() => {
  function getScrollAmount(viewport, track) {
    const firstSlide = track.querySelector(".single-collection-section__slide");

    if (!firstSlide) {
      return viewport.clientWidth;
    }

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;

    return firstSlide.getBoundingClientRect().width + gap;
  }

  function getVisibleSlidesCount(section) {
    if (window.matchMedia("(max-width: 479.98px)").matches) {
      return 1;
    }

    if (window.matchMedia("(max-width: 767.98px)").matches) {
      return 2;
    }

    if (window.matchMedia("(max-width: 991.98px)").matches) {
      return 3;
    }

    return section.classList.contains("product-recommendations") ? 5 : 4;
  }

  function getSlideWidthValue(section, viewportWidth, gap) {
    const visibleSlides = getVisibleSlidesCount(section);

    if (visibleSlides === 1) {
      return `${viewportWidth * 0.78}px`;
    }

    return `${(viewportWidth - gap * (visibleSlides - 1)) / visibleSlides}px`;
  }

  function applyResponsiveSlidesWidth(section, viewport, track) {
    const slides = track.querySelectorAll(".single-collection-section__slide");

    if (!slides.length) {
      return;
    }

    const viewportWidth = viewport.clientWidth;

    if (!viewportWidth) {
      return;
    }

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
    const slideWidth = getSlideWidthValue(section, viewportWidth, gap);

    slides.forEach((slide) => {
      slide.style.flex = `0 0 ${slideWidth}`;
      slide.style.maxWidth = slideWidth;
    });
  }

  function updateProductRecommendationsNavigation(section, viewport, track) {
    if (!section.classList.contains("product-recommendations")) {
      return;
    }

    const slides = track.querySelectorAll(".single-collection-section__slide");
    const visibleSlides = getVisibleSlidesCount(section);
    const hasHiddenSlides = slides.length > visibleSlides;
    const hasScrollOverflow = viewport.scrollWidth - viewport.clientWidth > 1;

    section.classList.toggle(
      "is-slider-nav-visible",
      hasHiddenSlides && hasScrollOverflow
    );
  }

  function updateSliderNavigation(section) {
    const viewport = section.querySelector("[data-single-collection-viewport]");
    const track = section.querySelector("[data-single-collection-track]");
    const prevButton = section.querySelector("[data-single-collection-prev]");
    const nextButton = section.querySelector("[data-single-collection-next]");

    if (!viewport || !prevButton || !nextButton) {
      return;
    }

    if (track) {
      updateProductRecommendationsNavigation(section, viewport, track);
    }

    const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
    const currentScrollLeft = viewport.scrollLeft;

    prevButton.disabled = currentScrollLeft <= 1;
    nextButton.disabled = currentScrollLeft >= maxScrollLeft - 1;
  }

  function initSingleCollectionSection(section) {
    const viewport = section.querySelector("[data-single-collection-viewport]");
    const track = section.querySelector("[data-single-collection-track]");

    if (section.dataset.singleCollectionInitialized === "true") {
      if (viewport && track) {
        applyResponsiveSlidesWidth(section, viewport, track);
        updateProductRecommendationsNavigation(section, viewport, track);
      }

      updateSliderNavigation(section);
      return;
    }

    const prevButton = section.querySelector("[data-single-collection-prev]");
    const nextButton = section.querySelector("[data-single-collection-next]");
    let resizeFrame = null;

    if (!viewport || !track || !prevButton || !nextButton) {
      return;
    }

    const syncSliderLayout = () => {
      applyResponsiveSlidesWidth(section, viewport, track);
      updateSliderNavigation(section);
    };

    prevButton.addEventListener("click", () => {
      viewport.scrollBy({
        left: getScrollAmount(viewport, track) * -1,
        behavior: "smooth",
      });
    });

    nextButton.addEventListener("click", () => {
      viewport.scrollBy({
        left: getScrollAmount(viewport, track),
        behavior: "smooth",
      });
    });

    viewport.addEventListener("scroll", () => {
      window.requestAnimationFrame(() => {
        updateSliderNavigation(section);
      });
    });

    window.addEventListener("resize", () => {
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = window.requestAnimationFrame(() => {
        syncSliderLayout();
      });
    });

    section.querySelectorAll("[data-single-product-card]").forEach((card) => {
      card.addEventListener("click", (event) => {
        const clickedInteractive = event.target.closest("a, button, input, select, textarea, form");

        if (clickedInteractive) {
          return;
        }

        const productUrl = card.dataset.productUrl;

        if (productUrl) {
          window.location.href = productUrl;
        }
      });
    });

    section.dataset.singleCollectionInitialized = "true";

    syncSliderLayout();
  }

  function initSingleCollectionSections(scope = document) {
    const sections = scope.querySelectorAll("[data-single-collection-section]");

    sections.forEach((section) => {
      initSingleCollectionSection(section);
    });
  }

  window.singleCollectionSliderUi = {
    init: initSingleCollectionSections,
  };

  document.addEventListener("DOMContentLoaded", () => {
    initSingleCollectionSections();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initSingleCollectionSections(event.target);
  });
})();
